import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    basePath: 'http://rbc-energo.ru',
    send: false
  },

  mutations: {},

  actions: {
    async Send (context, payload) {
      if ((Vue.config.devtools)) {
        console.log(payload)
      } else {
        const fields = {
          title: payload.setting.title,
          subject: payload.setting.subject,
          fields: payload.fields
        }

        const formData = new FormData()
        formData.append('fields', JSON.stringify(fields))

        if (payload.files !== '') {
          for (let i = 0; i < payload.files.length; i++) {
            let file = payload.files[i]
            formData.append('files[' + i + ']', file)
          }
        }

        await fetch(`/api/v1/send_form/`, {
          method: 'POST',
          body: formData
        })
      }
    }
  },

  getters: {
    getBasePath: s => s.basePath,
    getSend: s => s.send
  }
})



// WEBPACK FOOTER //
// ./src/store/form.js